/* eslint-disable import/no-unused-modules */

import React, { ReactElement, ChangeEventHandler } from 'react'
import Text from '../../text'
import { Radio, Inputs, StyledInput, StyledText } from './styled-components'

interface RadioInputProps {
  id: string
  correctAnswers: string[]
  answers: string[]
  onValueChange?: ChangeEventHandler<HTMLInputElement>
}

function RadioInput({
  onValueChange,
  correctAnswers,
  answers,
  id,
}: RadioInputProps): ReactElement {
  return (
    <Radio>
      <Inputs>
        <StyledText>
          <StyledInput
            type="radio"
            name="quiz"
            value={answers[0]}
            id={String(id)}
            onChange={onValueChange}
            defaultChecked={correctAnswers.includes(answers[0])}
          />
          <Text>{answers[0]}</Text>
        </StyledText>
        <StyledText>
          <StyledInput
            type="radio"
            name="quiz"
            value={answers[1]}
            id={String(id)}
            onChange={onValueChange}
            defaultChecked={correctAnswers.includes(answers[1])}
          />
          <Text>{answers[1]}</Text>
        </StyledText>
      </Inputs>
    </Radio>
  )
}

export default RadioInput
